const HelpBlue = ({ size = 54 }) => (
  <svg
    id="HelpBlue"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 54 54"
    fill="none"
  >
    <path
      d="M29.2068 48.4397C39.9174 48.4397 48.6 39.7571 48.6 29.0465C48.6 18.336 39.9174 9.65332 29.2068 9.65332C18.4962 9.65332 9.8136 18.336 9.8136 29.0465C9.8136 39.7571 18.4962 48.4397 29.2068 48.4397Z"
      fill="#8ACEFF"
    />
    <path
      d="M24.7608 45.3616C19.3356 45.3616 14.2128 43.225 10.3338 39.3478C6.45661 35.4706 4.32001 30.346 4.32001 24.9208C4.32001 19.4956 6.45661 14.3728 10.3338 10.4938C14.211 6.61658 19.3356 4.47998 24.7608 4.47998C30.186 4.47998 35.3088 6.61658 39.1878 10.4938C43.065 14.371 45.2016 19.4956 45.2016 24.9208C45.2016 25.5166 44.7174 26.0008 44.1216 26.0008C43.5258 26.0008 43.0416 25.5166 43.0416 24.9208C43.0416 20.0734 41.13 15.4924 37.6596 12.022C34.1892 8.55158 29.6082 6.63998 24.7608 6.63998C19.9134 6.63998 15.3306 8.55158 11.862 12.022C8.39161 15.4924 6.48001 20.0734 6.48001 24.9208C6.48001 29.7682 8.39161 34.351 11.862 37.8196C15.3324 41.29 19.9134 43.2016 24.7608 43.2016C30.429 43.2016 35.865 40.5106 39.3012 36.0016C39.663 35.5264 40.3398 35.4346 40.815 35.7964C41.2902 36.1582 41.3802 36.835 41.0202 37.3102C37.179 42.352 31.1004 45.3616 24.7626 45.3616H24.7608Z"
      fill="#5A348C"
    />
    <path
      d="M24.7608 36.72C23.9652 36.72 23.3208 36.0756 23.3208 35.28V22.545C23.3208 21.7494 23.9652 21.105 24.7608 21.105C25.5564 21.105 26.2008 21.7494 26.2008 22.545V35.28C26.2008 36.0756 25.5564 36.72 24.7608 36.72Z"
      fill="#5A348C"
    />
    <path
      d="M24.7608 18.1492C25.8931 18.1492 26.811 17.2313 26.811 16.099C26.811 14.9667 25.8931 14.0488 24.7608 14.0488C23.6285 14.0488 22.7106 14.9667 22.7106 16.099C22.7106 17.2313 23.6285 18.1492 24.7608 18.1492Z"
      fill="#5A348C"
    />
  </svg>
);

export default HelpBlue;
